<template lang="html">
  <div class="container-fluid">
    <div>
<table class="table table-hover table-sm col-md-11" ref="holdingtable" :data="holdings">
  <caption>Total = {{holdtotal}}</caption>
  <thead>
    <div class = "row" slot="header">
      <h3 scope="col">
       Holdings 
      </h3>
    </div>
    <tr>
      <th class="text-center" scope="col">Account Name</th>
      <th class="text-center" scope="col">Taxable</th>
      <th class="text-center" scope="col">Account Value</th>
      <th class="text-center" scope="col"></th>
    </tr>
  </thead>
  <tbody>
        <tr v-for="(holding, index) in holdings" v-bind:key="index" >
          <td class="text-center" scope="row">
            {{holding.account}}
          </td>
          <td class="text-center">
            {{holding.taxable}}
          </td>
            <td class="text-center">
            {{holding.amount}}
          </td>
          <td>
          <img @click.prevent="deleteholding(holding.id, index)" src="./icons/minus-circle.svg"></img>
          </td>
        </tr>
  </tbody>
  </table>
  </div>
<form v-on:submit.prevent="addholding">
<div class="form-row">
    <div class="form-group col-md-3">
    
      <input type="text" class="form-control" id="account" placeholder="Account Name" v-model="account">
    </div>
    <div class="form-group col-md-3">
          <select class="custom-select" id="inlineFormCustomSelectPref" v-model="taxable">
          <option value="Taxable">Taxable</option>
          <option value="Non-Taxable">Non-Taxable</option>
        </select>
      
    </div>
    <div class="form-group col-md-3">
      
      <input type="text" class="form-control" id="amount" placeholder="Account Value" v-model="amount">
    </div>
    <div class="form-group col-md-3">
      <button type="submit" class="btn btn-primary">Add Account</button>
    </div>
</div>
</form>
<button @click.prevent="linkaccounts()" class="btn btn-primary">Link Account(s)</button>
<button @click.prevent="loadaccounts()" class="btn btn-primary">Load Account(s)</button>
  </div>
</template>

<script>
import db from './firebaseInit'
import firebase from 'firebase/app'
import axios from 'axios'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
require('@firebase/storage');
require('@firebase/performance');



export default {
  name: 'holdingtable',
  data () {
    return {
      holdings: [],
      holdtotal: '',
      account: null,
      taxable: null,
      amount: null,
      access_token: null,
      userid: null
    }
  },
  created: function(){
    this.loaddata();
    var user = firebase.auth().currentUser;
   if (user != null) {
      this.userid = user.uid;
      } 

  },
  mounted: function(){
   
  },
  methods: {
  loaddata: function(){
    var userId
    this.holdings = []
  var user = firebase.auth().currentUser;
   if (user != null) {
      userId = user.uid;
      } 
      var holdtotal = 1
      
  db.collection('users').doc(userId).collection('holdings').get().then
  (querySnapshot => {
    var hldtotal= 0;
    querySnapshot.forEach(doc => {
      //console.log(doc.data());
      const data = {
        'id' : doc.id,
        'account' : doc.data().account,
        'amount' : '$' + (doc.data().amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
        'taxable' : doc.data().taxable
      }
      
      hldtotal += doc.data().amount
      this.holdtotal = '$' + (hldtotal ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      this.holdings.push(data)
      //this.holdtotal.push(total)
      return hldtotal
      //console.log(data)
      
    }) 
  }
  )
  
    },
    addholding: function(){
  var user = firebase.auth().currentUser;
  var userId
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('holdings').add({
    account: this.account,
    taxable: this.taxable,
    amount: parseFloat(this.amount)
  }).then(ref => {
  console.log('Added document with ID: ', this.amount) 
  const data = {
        'id' : ref.id,
        'account' : this.account,
        'amount' : '$' + parseFloat(this.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
        'txable' : this.txable
      }
  //this.holdings.push(data)  
  this.loaddata()
  this.account = ''
  this.taxable = ''
  this.amount = ''
})
},
deleteholding: function(id,index){
  var user = firebase.auth().currentUser;
  var userId
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('holdings').doc(id).delete().then(function() {
      console.log(index);

}).catch(function(error) {
  // Uh-oh, an error occurred!
});
this.holdings.splice(index, 1);
},
linkaccounts: function(){

var user = firebase.auth().currentUser;
  var userId
   if (user != null) {
      userId = user.uid;
      } 
//console.log("Accounts Linked!")
    var handler = Plaid.create({
      apiVersion: 'v2',
      clientName: 'Plaid Quickstart',
      env: 'sandbox',
      product: 'transactions',
      key: '983022d7ccb5c112fff61a5452265a',
      countryCodes: 'US,CA,GB,FR,ES'.split(','),
      //webhook: 'https://us-central1-lyfe-planner.cloudfunctions.net/plaidapp',
      onSuccess: public_token => {
      console.log(public_token)
        axios.post('/api/v1/get_access_token/', {
          public_token: public_token
        }).then((res) => {
          
  db.collection('users').doc(userId).collection('plaid').doc('auth').set({
    access_token: res.data.access_token,
    item_id: res.data.item_id
  })
          console.log(res.data.access_token)

          //this.access_token = res.data.access_token
          //console.log(atoken)
          
        }).catch(function (error){
          console.log(error)
        })

      }
    });
    handler.open();
 
},
loadaccounts: function(){
  var userId = this.userid
 
   db.collection('users').doc(userId).collection('plaid').doc('auth').get().then
  (snap => {
    const data = {'access_token' : snap.data().access_token} 
 
axios.get('/api/v1/accounts/', data).then(function (data){
console.log(data)
})
 })
}

  },
  computed: {
  }

}
</script>